import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/splitcellcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { findAncestor } from "./utils";
/**
 * The split cell command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as `'splitTableCellVertically'`
 * and `'splitTableCellHorizontally'`  editor commands.
 *
 * You can split any cell vertically or horizontally by executing this command. For example, to split the selected table cell vertically:
 *
 *		editor.execute( 'splitTableCellVertically' );
 *
 * @extends module:core/command~Command
 */

var SplitCellCommand = /*#__PURE__*/function (_Command) {
  _inherits(SplitCellCommand, _Command);

  var _super = _createSuper(SplitCellCommand);

  /**
   * Creates a new `SplitCellCommand` instance.
   *
   * @param {module:core/editor/editor~Editor} editor The editor on which this command will be used.
   * @param {Object} options
   * @param {String} options.direction Indicates whether the command should split cells `'horizontally'` or `'vertically'`.
   */
  function SplitCellCommand(editor) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SplitCellCommand);

    _this = _super.call(this, editor);
    /**
     * The direction that indicates which cell will be split.
     *
     * @readonly
     * @member {String} #direction
     */

    _this.direction = options.direction || 'horizontally';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SplitCellCommand, [{
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      var tableCell = findAncestor('tableCell', doc.selection.getFirstPosition());
      this.isEnabled = !!tableCell;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      var document = model.document;
      var selection = document.selection;
      var firstPosition = selection.getFirstPosition();
      var tableCell = findAncestor('tableCell', firstPosition);
      var isHorizontally = this.direction === 'horizontally';
      var tableUtils = this.editor.plugins.get('TableUtils');

      if (isHorizontally) {
        tableUtils.splitCellHorizontally(tableCell, 2);
      } else {
        tableUtils.splitCellVertically(tableCell, 2);
      }
    }
  }]);

  return SplitCellCommand;
}(Command);

export { SplitCellCommand as default };